class HeaderInlineSearchAnimation {
  constructor(container) {
    this.container = container;
    this.input = container.querySelector('.header-inline-search .search__input');
    this.output = container.querySelector('.header-inline-search__animated-text');
    this.phrases = (container.dataset.headerSearchPhrases || '')
      .split('|')
      .map((phrase) => phrase.trim())
      .filter(Boolean);
    this.phraseIndex = 0;
    this.characterIndex = 0;
    this.direction = 1;
    this.timeoutId = null;

    if (!this.input || !this.output || !this.phrases.length) return;

    this.boundRestart = this.restart.bind(this);
    this.boundPause = this.pause.bind(this);

    this.input.addEventListener('focus', this.boundPause);
    this.input.addEventListener('blur', this.boundRestart);

    this.tick();
  }

  pause() {
    window.clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }

  restart() {
    if (!this.input.value) {
      this.tick();
    }
  }

  tick() {
    if (document.activeElement === this.input || this.input.value) {
      this.pause();
      return;
    }

    const currentPhrase = this.phrases[this.phraseIndex];
    this.output.textContent = currentPhrase.slice(0, this.characterIndex);

    if (this.direction === 1) {
      if (this.characterIndex < currentPhrase.length) {
        this.characterIndex += 1;
        this.timeoutId = window.setTimeout(() => this.tick(), 85);
      } else {
        this.direction = -1;
        this.timeoutId = window.setTimeout(() => this.tick(), 1100);
      }
      return;
    }

    if (this.characterIndex > 0) {
      this.characterIndex -= 1;
      this.timeoutId = window.setTimeout(() => this.tick(), 45);
      return;
    }

    this.direction = 1;
    this.phraseIndex = (this.phraseIndex + 1) % this.phrases.length;
    this.timeoutId = window.setTimeout(() => this.tick(), 250);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-header-search-phrases]').forEach((container) => {
    new HeaderInlineSearchAnimation(container);
  });
});